 function weixinClosePage () {
   if (typeof WeixinJSBridge === 'undefined') {
     if (document.addEventListener) {
       document.addEventListener('WeixinJSBridgeReady', weixin_ClosePage, false)
     } else if (document.attachEvent) {
       document.attachEvent('WeixinJSBridgeReady', weixin_ClosePage)
       document.attachEvent('onWeixinJSBridgeReady', weixin_ClosePage)
     }
   } else {
     weixin_ClosePage()
   }
 }
 function weixin_ClosePage () {
   WeixinJSBridge.call('closeWindow')
 }
 export default weixinClosePage



// WEBPACK FOOTER //
// ./src/utils/wxClosePage.js